import { Headings, NoneValue } from '../../../domain';

/**
 * Build import heading payloads with a consistent prev/next heading chain.
 * AI preview can render from nextQuestionId alone; Accept/import must persist
 * previousHeadingId + nextHeadingId (and previousQuestionId when available).
 */
export var mapHeadingsForImport = function mapHeadingsForImport(headings, questions) {
  if (!(headings !== null && headings !== void 0 && headings.length)) {
    return [];
  }

  var sectionIds = Array.from(new Set(headings.map(function (heading) {
    return heading.sectionId;
  })));
  var result = [];
  sectionIds.forEach(function (sectionId) {
    var sectionHeadings = headings.filter(function (heading) {
      return heading.sectionId === sectionId;
    });
    var sectionQuestions = questions.filter(function (question) {
      return question.sectionId === sectionId;
    });
    var orderedHeadings = Headings.sort(sectionHeadings);

    if (orderedHeadings.length !== sectionHeadings.length) {
      var interleaved = Headings.sortWithQuestions(sectionHeadings, sectionQuestions);
      orderedHeadings = interleaved.filter(function (item) {
        return item.type === 'heading';
      });
      var orderedIds = new Set(orderedHeadings.map(function (heading) {
        return heading.id.toString();
      }));
      sectionHeadings.forEach(function (heading) {
        if (!orderedIds.has(heading.id.toString())) {
          orderedHeadings.push(heading);
        }
      });
    }

    var interleavedForBounds = Headings.sortWithQuestions(orderedHeadings, sectionQuestions);
    orderedHeadings.forEach(function (heading, index) {
      var previousHeadingId = index === 0 ? NoneValue : orderedHeadings[index - 1].id.toString();
      var nextHeadingId = index === orderedHeadings.length - 1 ? NoneValue : orderedHeadings[index + 1].id.toString();
      var previousQuestionId = heading.previousQuestionId;

      if (previousQuestionId === NoneValue) {
        var headingIndex = interleavedForBounds.findIndex(function (item) {
          return item.id.toString() === heading.id.toString();
        });

        if (headingIndex > 0) {
          var previousItem = interleavedForBounds[headingIndex - 1];

          if (previousItem.type !== 'heading') {
            previousQuestionId = previousItem.id.toString();
          }
        }
      }

      result.push({
        id: heading.id.toString(),
        description: heading.description || undefined,
        title: heading.title,
        formId: heading.formId,
        sectionId: heading.sectionId,
        nextQuestionId: heading.nextQuestionId,
        previousQuestionId: previousQuestionId,
        previousHeadingId: previousHeadingId,
        nextHeadingId: nextHeadingId
      });
    });
  });
  return result;
};